export default "__VITE_ASSET__68014d90__"